import { embedQuizType, getUserGUID } from 'utils/commonFunctions';
import { DEFAULT_API_VERSION } from 'utils/constants';

export const urlTemplates = {
  config: '/feeds/config.json',
  getGamelist: '/services/card/{version}/{competition}/gamelist',
  getPendingAttempt: '/services/card/{version}/{competition}/pending-attempt',
  getUserDetails: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/userdetails',
  userAttempt: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/attempt',
  settelment: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/settlement',
  registerQuestion: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/registerquestion',
  fiftyFiftyBooster: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/fifty',
  thirdUmpireBooster: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/sneakpeak',
  scoreCard: '/services/Gameplay/{version}/{competition}/{guid}/{quizId}/scorecard',
  subscribe: '/services/Session/{version}/subscribe',
  login: '/services/Session/{version}/{competition}/login',
  shareGraphic: '/services/Share/{version}/{competition}/{guid}/{quizId}/generate',
  getLeaderboard:
    '/services/live/leaderboard/{version}/{competition}/{leaderboardType}/get-leaderboard',
  getLeaderboardGuest: '/feeds/leaderboard/{quizId}_{leaderboardType}.json',
  getSelfRank:
    '/services/live/leaderboard/{version}/{competition}/{leaderboardType}/get-user-ranking-leaderboard',
  getTopRanking:
    '/services/live/leaderboard/{version}/{competition}/{leaderboardType}/get-top-rankings',
  getTopRankingGuest: '/feeds/toprankings/{leaderboardType}.json',
  getLeaderboardTabs: '/services/card/{version}/{competition}/get-quiz-by-theme'
};

export const defaultPathParams = {
  version: DEFAULT_API_VERSION,
  guid: getUserGUID(),
  competition: embedQuizType()?.toLowerCase() ?? "daily"
};
